/* ============================================================
   HARVEST SKIN 2026 — ambient canvas
   Slow-falling autumn leaves + golden dust motes, fixed to viewport.
   - pointer-events: none (never blocks clicks)
   - low opacity via CSS (#tg-ambient-canvas)
   - disabled when prefers-reduced-motion is set
   - zero dependencies
   ============================================================ */
(function () {
  'use strict';

  // Respect users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Don't double-init (e.g. theme editor re-renders)
  if (document.getElementById('tg-ambient-canvas')) return;

  var canvas = document.createElement('canvas');
  canvas.id = 'tg-ambient-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var W, H, particles = [];

  // harvest palette: gold, amber, russet, cranberry, olive
  var LEAF_COLORS = ['#d9a441', '#c2571b', '#8e2a3c', '#a36a1f', '#7d6a2a'];
  var MOTE_COLORS = ['#f0c987', '#e8b04b'];

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  function makeLeaf() {
    return {
      type: 'leaf',
      x: Math.random() * W,
      y: -20 - Math.random() * 40,
      size: 6 + Math.random() * 10,
      vy: 0.4 + Math.random() * 1.0,   // slow, lazy drift
      vx: -0.5 + Math.random() * 1.0,
      angle: Math.random() * Math.PI * 2,
      spin: -0.025 + Math.random() * 0.05,
      swayAmp: 20 + Math.random() * 40,
      swaySpeed: 0.004 + Math.random() * 0.012,
      t: Math.random() * 1000,
      color: LEAF_COLORS[(Math.random() * LEAF_COLORS.length) | 0]
    };
  }

  function makeMote() {
    return {
      type: 'mote',
      x: Math.random() * W,
      y: Math.random() * H,
      size: 1 + Math.random() * 2.5,
      vy: -0.15 - Math.random() * 0.35, // gentle rise, like warm air
      vx: -0.3 + Math.random() * 0.6,
      t: Math.random() * 1000,
      twinkleSpeed: 0.01 + Math.random() * 0.03,
      color: MOTE_COLORS[(Math.random() * MOTE_COLORS.length) | 0]
    };
  }

  function seed() {
    particles = [];
    var leafCount = Math.min(42, Math.floor(W / 30));
    for (var i = 0; i < leafCount; i++) {
      var leaf = makeLeaf();
      leaf.y = Math.random() * H; // pre-scatter so the screen isn't empty on load
      particles.push(leaf);
    }
    var moteCount = Math.min(26, Math.floor(W / 48));
    for (var j = 0; j < moteCount; j++) {
      particles.push(makeMote());
    }
  }
  seed();

  function drawLeaf(p) {
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.angle);
    ctx.fillStyle = p.color;
    ctx.globalAlpha = 0.75;
    // simple leaf: ellipse + stem
    ctx.beginPath();
    ctx.ellipse(0, 0, p.size, p.size * 0.55, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = 'rgba(0,0,0,0.25)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(-p.size, 0);
    ctx.lineTo(-p.size - 4, -3);
    ctx.stroke();
    ctx.restore();
  }

  function drawMote(p) {
    var tw = 0.45 + 0.55 * Math.abs(Math.sin(p.t * p.twinkleSpeed));
    ctx.save();
    ctx.globalAlpha = tw * 0.8;
    ctx.fillStyle = p.color;
    ctx.beginPath();
    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  function tick() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.t++;

      if (p.type === 'leaf') {
        p.y += p.vy;
        p.x += p.vx + Math.sin(p.t * p.swaySpeed) * 0.8;
        p.angle += p.spin;
        drawLeaf(p);
        if (p.y > H + 30 || p.x < -40 || p.x > W + 40) {
          particles[i] = makeLeaf();
        }
      } else {
        p.x += p.vx;
        p.y += p.vy;
        drawMote(p);
        if (p.y < -20 || p.x < -20 || p.x > W + 20) {
          particles[i] = makeMote();
        }
      }
    }
    requestAnimationFrame(tick);
  }

  // Pause when the tab is hidden to save battery
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) requestAnimationFrame(tick);
  });

  requestAnimationFrame(tick);
})();
